import { render } from "./ReadingStats.vue?vue&type=template&id=d6963482&scoped=true"
import script from "./ReadingStats.vue?vue&type=script&lang=js"
export * from "./ReadingStats.vue?vue&type=script&lang=js"

import "./ReadingStats.vue?vue&type=style&index=0&id=d6963482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6963482"]])

export default __exports__